import { RouterProvider } from 'react-router-dom'
import { Analytics } from '@vercel/analytics/react'
import { SpeedInsights } from '@vercel/speed-insights/react'
import { useAppDispatch } from './hooks'
import { router } from './router'
import { fetchAuthUser } from './store/auth.slice'

export const App = () => {
  const dispatch = useAppDispatch()

  const authUserId = localStorage.getItem('uid')

  if (authUserId) {
    dispatch(fetchAuthUser(authUserId))
  }

  return (
    <RouterProvider router={router}>
      <Analytics />
      <SpeedInsights />
    </RouterProvider>
  )
}
